import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import AdminSimpleResourceMobile from "../mobile/admin/AdminSimpleResourceMobile";
import GestionDevise from "./GestionDevise";

export default function ResponsiveGestionDevise(props) {
  return useIsMobile() ? <AdminSimpleResourceMobile resource="currencies" {...props} /> : <GestionDevise {...props} />;
}
